import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-custom-checkbox',
  templateUrl: './custom-checkbox.component.html',
  styleUrls: ['./custom-checkbox.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomCheckboxComponent),
      multi: true
    }
  ],
  imports: [CheckboxModule, CommonModule, FormsModule, ReactiveFormsModule, TableModule]
})
export class CustomCheckboxComponent implements ControlValueAccessor {

  onChange: (value: boolean) => void = () => { };
  onTouched: () => void = () => { };
  disabled: boolean = false;
  value: boolean = false;

  @Input() labelText: string = "";
  @Output() onChangeCheckBox = new EventEmitter<boolean>();
  checkboxId: string = "";

  ngOnInit() {
    this.checkboxId = this.labelText.trim();
  }

  changeCheckBox(event: CheckboxChangeEvent) {
    this.value = event.checked ?? false;
    this.onChange(this.value);
    this.onTouched();
    this.onChangeCheckBox.emit(this.value);
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: boolean): void {
    this.value = !!value;
  }

}
